import type { AppConfig } from '~/core/app-config';

const PROD = import.meta.env.PROD;

/**
 * Build-time defaults. Overridden at runtime by `public/config.json` via
 * appConfigService.load(). Production builds default to live OIDC; dev to mock.
 */
export const environment: AppConfig = {
  production: PROD,
  basePath: '',
  authMode: PROD ? 'oidc' : 'mock',
  apiBase: '',
  workspaceName: '',
  bff: {
    login: '/bff/login',
    logout: '/bff/logout',
    userinfo: '/bff/userinfo',
    streamTickets: '/bff/stream/tickets',
    upload: '/bff/upload',
    download: '/bff/download',
    presence: '/bff/presence',
    places: '/bff/places',
    okfExport: '/bff/okf/export',
    okfImport: '/bff/okf/import',
  },
  oidc: {
    issuer: '',
    clientId: 'lumendesk-console',
    scope: 'openid profile email',
    redirectUri: '',
    postLogoutRedirectUri: '',
  },
  ticketing: {
    enabled: PROD,
    baseUrl: '',
    tenantId: '',
  },
  control: {
    baseUrl: '',
  },
  setup: {
    slug: '',
  },
};
